import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';

export type EmailRecipientRole = 'student' | 'parent' | 'mentor' | 'staff' | 'internal' | 'unknown';

export type EmailRecipientDTO = {
  email: string;
  name?: string;
  role: EmailRecipientRole;
  relatedStudent?: string;
};

export type EmailDeliveryStatusDTO =
  | 'processed'
  | 'deferred'
  | 'delivered'
  | 'bounced'
  | 'dropped'
  | 'spam';

export type EmailLogRowDTO = {
  _id: string;
  subject: string;
  from: string;
  to: EmailRecipientDTO[];
  cc: EmailRecipientDTO[];
  successful: boolean;
  error?: string;
  deliveryStatus?: EmailDeliveryStatusDTO;
  deliveryReason?: string;
  openedAt?: string;
  resendOf?: string;
  resentEmailId?: string;
  resentAt?: string;
  createdAt: string;
};

export type EmailLogDetailDTO = EmailLogRowDTO & {
  html?: string;
  text?: string;
  sendgridMessageId?: string;
  attachmentNames: string[];
  clickedAt?: string;
  deliveryEvents: { event: string; timestamp: string; reason?: string }[];
  resentByName?: string;
};

export type EmailLogPersonDTO = {
  _id: string;
  name: string;
  email: string;
  isDeactivated: boolean;
};

export type EmailLogStatusFilter = 'sent' | 'failed' | 'delivered' | 'bounced' | 'opened';

export type EmailLogFilters = {
  search?: string;
  studentId?: string;
  studentScope?: 'both' | 'student' | 'parent';
  mentorId?: string;
  recipientType?: 'student' | 'parent' | 'mentor' | 'internal';
  status?: EmailLogStatusFilter;
  year?: number;
  month?: number;
  page?: number;
  limit?: number;
};

export const searchEmails: ApiDescription = {
  endpoint: '/admin/emails',
  method: RequestsMethod.Get,
};

export type SearchEmails = ApiData<
  EmailLogFilters,
  {
    emails: EmailLogRowDTO[];
    total: number;
    failed: number;
    bounced: number;
    page: number;
    limit: number;
  }
>;

export const getEmail: ApiDescription = {
  endpoint: '/admin/emails/:id',
  method: RequestsMethod.Get,
};

export type GetEmail = ApiData<unknown, EmailLogDetailDTO>;

export const searchEmailPeople: ApiDescription = {
  endpoint: '/admin/email-people',
  method: RequestsMethod.Get,
};

export type SearchEmailPeople = ApiData<
  { search?: string; role: 'student' | 'mentor' },
  EmailLogPersonDTO[]
>;

export const resendEmail: ApiDescription = {
  endpoint: '/admin/emails/:id/resend',
  method: RequestsMethod.Post,
};

export type ResendEmail = ApiData<unknown, EmailLogRowDTO>;
